(function() {
  const initV3Specs = () => {
    const containers = document.querySelectorAll('.achg-v3-main-container');

    containers.forEach(box => {
      const slider = box.querySelector('.achg-v3-slider-engine');
      if (!slider || box.classList.contains('js-ready')) return;

      let isDown = false;
      let startX;
      let scrollLeft;
      let hasMoved = false;

      box.addEventListener('mousedown', (e) => {
        isDown = true;
        hasMoved = false;
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
        e.stopPropagation();
      }, true);

      window.addEventListener('mouseup', () => {
        isDown = false;
      });

      box.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 2;
        if (Math.abs(walk) > 5) {
          hasMoved = true;
          e.preventDefault();
          e.stopPropagation();
          slider.scrollLeft = scrollLeft - walk;
        }
      }, true);

      box.addEventListener('click', (e) => {
        if (hasMoved) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);

      const nodes = Array.from(slider.querySelectorAll('.achg-v3-item-node'));
      if (nodes.length > 0) {
        nodes.sort((a, b) => (parseInt(a.dataset.weight) || 0) - (parseInt(b.dataset.weight) || 0));
        nodes.forEach(n => slider.appendChild(n));
      }
      box.classList.add('js-ready');
    });
  };

  initV3Specs();
  document.addEventListener('shopify:section:load', initV3Specs);
  const observer = new MutationObserver(initV3Specs);
  observer.observe(document.body, { childList: true, subtree: true });
})();